"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Container = _interopRequireDefault(require("./Container"));

var _default = function _default(_ref) {
  var config = _ref.config,
      _ref$activeCriteria = _ref.activeCriteria,
      activeCriteria = _ref$activeCriteria === void 0 ? 'from' : _ref$activeCriteria,
      _onClick = _ref.onClick,
      left = _ref.left,
      right = _ref.right;
  return /*#__PURE__*/_react["default"].createElement(_Container["default"], {
    left: left,
    right: right
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "h-full flex flex-col justify-center"
  }, config.map(function (each) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: each.name,
      className: (0, _classnames["default"])('text-6xl', activeCriteria === each.name ? 'text-primary' : 'text-dark')
    }, /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: "font-semibold hover:text-primary",
      onClick: function onClick() {
        return _onClick(each.name);
      }
    }, each.label));
  })));
};

exports["default"] = _default;
//# sourceMappingURL=Criteria.js.map